import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import horizontalLogo from '../../../assets/images/adas-intelligence-horizontal-logo.svg'

const tabClass = (isActive) =>
  `pb-3 text-[14px] font-medium transition-colors ${
    isActive ? 'text-[#1F6FEB] border-b-2 border-[#1F6FEB]' : 'text-[#6B7280] hover:text-[#334155]'
  }`

export const AdasIntelligenceHeader = ({ title = 'ADAS Intelligence', subtitle, right }) => (
  <div className='mb-4 flex items-center justify-between'>
    <div>
      <h1 className='m-0 leading-none'>
        <img src={horizontalLogo} alt={title} className='h-12 w-auto' />
      </h1>
      {subtitle && <p className='mt-1 text-[13px] text-[#6B7280]'>{subtitle}</p>}
    </div>
    {right}
  </div>
)

AdasIntelligenceHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  right: PropTypes.node
}

export const AdasIntelligenceTabs = () => (
  <nav className='mb-6 flex items-center gap-6 border-b border-[#D1D5D8]'>
    <NavLink
      to='/adas-intelligence'
      exact
      className={({ isActive }) => tabClass(isActive)}
      activeClassName='text-[#1F6FEB] border-b-2 border-[#1F6FEB]'
    >
      {({ isActive }) => <span className={tabClass(isActive)}>Queue</span>}
    </NavLink>
    <NavLink
      to='/adas-intelligence/reports'
      className={({ isActive }) => tabClass(isActive)}
      activeClassName='text-[#1F6FEB] border-b-2 border-[#1F6FEB]'
    >
      {({ isActive }) => <span className={tabClass(isActive)}>Reports</span>}
    </NavLink>
  </nav>
)
